import React from 'react';
import UploadFile from './uploadfile/uploadfile';
import Card from './post/card';
import WallList from './common/WallList';
// import { Carousel } from 'react-responsive-carousel';




class Upload extends React.Component {

    render() {
        return (
            <div>
                <UploadFile pageData={this.props.pageData} module_name={this.props.module_name} type={this.props.type} />
                {/* <Card module_name={this.props.module_name} type={this.props.type} /> */}
                <WallList module_name={this.props.module_name} type={this.props.type} />

            </div>

        )
    }
}

export default Upload;